import { INewRating } from '@app-types/websocket/rating.types';
import { createAction } from 'redux-act';

export const submitRating = createAction<INewRating>('Submit rating');
export const requestRatingPrompt = createAction('Request rating prompt');
export const displayRatingPrompt = createAction('Display rating prompt');
export const dismissRatingPrompt = createAction('Dismiss rating prompt');



// WEBPACK FOOTER //
// ./src/services/rating/rating.actions.ts